import React from "react";
import RegistrationForm from "../../Components/RegistrationForm/RegistrationForm";
import { Helmet } from "react-helmet-async";
import "./NotFound.css";

class NotFound extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleBackToHome = () => {
    this.props.history.push("/");
  };

  render() {
    return (
      <RegistrationForm
        containerClassName="container-not-found"
        hasCounter={false}
        hasQuote={true}
        quote="The page you are looking for cannot be found"
        headerText="404 - Page not found"
        primaryButtonText="Back to home"
        hasSkip={false}
        handlePrimaryBtnOnClick={this.handleBackToHome}
        activatePrimaryWithEnter={true}
        showButton={true}
        showBackButton={false}
      >
        <Helmet>
          <title>Astronomic Network</title>
          <meta
            name="description"
            content="Austin entrepreneurs helping each other win"
          />
        </Helmet>
      </RegistrationForm>
    );
  }
}

export default NotFound;
